import { buildScopedI18n } from '../../utils/buildScopedI18n';
import dailyEsCL from './locales/es-CL.json';
import dailyEnUS from './locales/en-US.json';
import dailyPtBR from './locales/pt-BR.json';

export const dailyStateI18n = buildScopedI18n({
  esCL: dailyEsCL,
  enUS: dailyEnUS,
  ptBR: dailyPtBR,
});
